import React, { useState } from "react";
import Card from 'components/card';
import Box from '@mui/material/Box';
import { Tabs, Tab } from '@mui/material';
import { Box as MuiBox } from '@mui/material';

// Import tab components
import SubcategoriesTab from './tabs/SubcategoriesTab';
import TemplateTab from './tabs/TemplateTab';

// Import shared components
import TabPanel from './components/TabPanel';

const AdditionalCostSettings = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div className="flex flex-col gap-5">
      <div className="mt-5 grid h-full">
        <h1 className="text-2xl font-bold text-navy-700 dark:text-white">
          Additional Costs Settings
        </h1>
        <p className="mt-2 text-base text-gray-600">
          Configure subcategories and templates for additional costs
        </p>
      </div>
      
      <Card extra={'w-full h-full bg-white'}>
        <MuiBox sx={{ width: '100%' }}>
          <MuiBox sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={tabValue} onChange={handleTabChange} aria-label="Additional costs settings tabs">
              <Tab label="Subcategories" />
              <Tab label="Template" />
            </Tabs>
          </MuiBox>
          <TabPanel value={tabValue} index={0}>
            <Box sx={{ p: 2 }}>
              <SubcategoriesTab />
            </Box>
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <Box sx={{ p: 2 }}>
              <TemplateTab />
            </Box>
          </TabPanel>
        </MuiBox>
      </Card>
    </div>
  );
};

export default AdditionalCostSettings;